import { useCallback, useRef } from 'react'

/**
 * Like use callback, but returns a ref instead, so can be safely used in async js code
 * @deprecated: Do not use this function, use useStateRef instead. Only use if you really know what you are doing.
 */
export default function useCallbackRef<T extends (...args: unknown[]) => unknown>(
  callback: T,
  deps: React.DependencyList
): React.MutableRefObject<T> {
  // oxlint-ignore-next-line react/exhaustive-deps
  const callbackMemoized = useCallback(callback, deps)
  const callbackRef = useRef(callbackMemoized)
  callbackRef.current = callbackMemoized

  return callbackRef
}
